
import React from 'react'
import { Row, Col, Layout, Table, Button, Pagination, Modal, Tag, message, Dropdown, Menu } from 'antd'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ExclamationCircleOutlined, EllipsisOutlined } from '@ant-design/icons';
import { getUser } from '../../../../utilities/token'
import { submitCommendation, loadCommendation, deleteCommendation } from '../actions'
import AddSlide from './slides/add'
import EditSlide from './slides/edit'
import './index.scss'
import moment from 'moment'
import ServiceNavLink from '../../serviceNavLink'
import config from '../../../../config'
import { ImagePresignedUrl } from '../../../../utilities/renderer'

class Commendation extends React.Component {
    constructor() {
        super()
        this.state = {
            isAddSlideOpen: false,
            isEditSlideOpen: false,

            //pagination
            page: 1,
            limit: 10,
            searchTerm: '',

            tableData: []
        }
        this.addSlideToggle = this.addSlideToggle.bind(this)
        this.editSlideToggle = this.editSlideToggle.bind(this)
        this.handleDeleteCommendation = this.handleDeleteCommendation.bind(this)
    }

    handleDeleteCommendation(id) {
        const self = this
        Modal.confirm({
            title: 'Do you want to delete this item?',
            icon: <ExclamationCircleOutlined />,
            content: 'You cannot undo this.',
            onOk() {
                self.props.onDeleteCommendation(id)
            },
            onCancel() { },
        });
    }

    componentDidMount() {
        const { limit, searchTerm, page } = this.state
        const pagination = {
            page: page,
            limit: limit,
            searchTerm: searchTerm
        }
        this.props.onLoadCommendation(pagination)

        window.Echo.channel(`client-commendations-crud.${getUser().id}`)
            .listen('.client-commendations-crud-channel', (response) => {
                const { data } = response
                const index = this.state.tableData.findIndex(item => item.id === data.id)
                if (data.status === 0) {
                    this.state.tableData.splice(index, 1) // delete
                } else {
                    if (index !== -1) this.state.tableData[index] = data // update
                    else {
                        this.state.tableData.unshift({ ...data }) // create
                        this.state.tableData = this.state.tableData.slice(0, this.state.limit) // re-assigning and limit to 10
                    }
                }
                // this.setState({tableData: this.state.tableData})
                // this.setState are not working inside echo channel, 
                // regarding to this. <Table key/> key must be unique to know if there was a changed.
                this.forceUpdate()
            })
    }

    onChangePagination(page, limit) {
        const { searchTerm } = this.state
        const pagination = {
            page: page,
            limit: limit,
            searchTerm: searchTerm
        }
        this.props.onLoadCommendation(pagination)
        this.setState({ page, limit })
    }

    componentWillReceiveProps(nextProps) {
        const { limit, page, searchTerm } = this.state
        const pagination = {
            page: page,
            limit: limit,
            searchTerm: searchTerm
        }
        if ((this.props.addCommendationSuccess !== nextProps.addCommendationSuccess) && nextProps.addCommendationSuccess) {
            this.setState({ isAddSlideOpen: false })
            message.success("Commendation added successfully.")
            this.props.onLoadCommendation(pagination)
        }
        if ((this.props.updateCommendationSuccess !== nextProps.updateCommendationSuccess) && nextProps.updateCommendationSuccess) {
            this.setState({ isEditSlideOpen: false })
            message.success("Commendation edited successfully.")
            this.props.onLoadCommendation(pagination)
        }
        if ((this.props.deleteCommendationSuccess !== nextProps.deleteCommendationSuccess) && nextProps.deleteCommendationSuccess) {
            this.setState({ isEditSlideOpen: false })
            message.success("Commendation deleted successfully.")
            this.props.onLoadCommendation(pagination)
        }
        if ((this.props.commendationSuccess !== nextProps.commendationSuccess) && nextProps.commendationSuccess) {
            this.setState({ tableData: nextProps.commendationData.data })
        }
    }

    addSlideToggle() {
        this.setState({ isAddSlideOpen: !this.state.isAddSlideOpen })
    }

    editSlideToggle() {
        this.setState({ isEditSlideOpen: !this.state.isEditSlideOpen })
    }


    getStatus(status) {
        switch (status) {
            case 1:
                return <Tag color="gold">FOR APPROVAL</Tag>
            case 2:
                return <Tag color="lime">APPROVED</Tag>
            case 3:
                return <Tag color="geekblue">ONGOING</Tag>
            case 4:
                return <Tag color="green">COMPLETED</Tag>
            case 5:
                return <Tag color="magenta">CANCELLED</Tag>
            case 6:
                return <Tag color="red">REJECTED</Tag>
            default:
                break;
        }
    }

    getType(type) {
        switch (type) {
            case 1:
                return <Tag color="#2db7f5">COMMENDATION</Tag>
            case 2:
                return <Tag color="#108ee9">TESTIMONIALS</Tag>
            default:
                break;
        }
    }

    render() {
        const dataSource = this.state.tableData

        const columns = [
            {
                title: 'Service Ticket #',
                dataIndex: 'ticketNumber',
                key: 'ticketNumber',
                sorter: (a, b) => a.ticketNumber && a.ticketNumber.localeCompare(b.ticketNumber)
            },
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                sorter: (a, b) => a.title && a.title.localeCompare(b.title)
            },
            {
                title: 'Comment',
                dataIndex: 'comment',
                key: 'comment',
                sorter: (a, b) => a.comment && a.comment.localeCompare(b.comment)
            },
            {
                title: 'Date Created',
                dataIndex: 'created_at',
                key: 'created_at',
                sorter: (a, b) => new Date(b.created_at) - new Date(a.created_at),
                render: (item) => {
                    return (<span>{moment(item).format('LLL')}</span>)
                }
            },
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
                render: (item) => {
                    return (<span>{this.getType(item)}</span>)
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (item) => {
                    return (<span>{this.getStatus(item)}</span>)
                }
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'actions',
                render: (info, data) => {
                    return (
                        <div className='action-dropdown-btn'>
                            <Dropdown overlay={<Menu>
                                <Menu.Item onClick={() => this.setState({ selectedRow: data, isEditSlideOpen: true })}>
                                    <span>View</span>
                                </Menu.Item>
                                {
                                    data.status === 1 ?
                                        <Menu.Item onClick={() => this.handleDeleteCommendation(data.id)}  >
                                            <span>Delete</span>
                                        </Menu.Item>
                                        :
                                        <Menu.Item disabled  >
                                            <span style={{ color: 'red' }}>Unable to delete</span>
                                        </Menu.Item>
                                }
                            </Menu>} trigger={['click']}>
                                <span className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                    <EllipsisOutlined />
                                </span>
                            </Dropdown>
                        </div>
                    )
                }
            },
        ];
        return (
            <Layout>
                <Row>
                    <Col md={12} lg={12} xs={24} sm={24}>
                        <h1 style={{ fontSize: 24, marginLeft: 10 }}>COMMENDATIONS AND TESTIMONIALS</h1>
                        <Button type='primary' className='primary-btn' onClick={() => this.setState({ isAddSlideOpen: true })} style={{ marginBottom: 10 }}>+ ADD COMMENDATION / TESTIMONIAL</Button>
                    </Col>
                </Row>
                <Row gutter={32}>
                    <Col md={18} lg={18} xs={24} sm={24}>
                        <Table columns={columns} dataSource={dataSource} rowKey="id" key={(JSON.stringify(this.state.tableData))} pagination={false} loading={this.props.commendationLoading} />
                        <Row style={{ marginTop: 30, width: '100%' }}>
                            <Col md={24} lg={24} sm={24} xs={24} align="right" >
                                <Pagination defaultCurrent={this.state.page} onChange={(page, limit) => this.onChangePagination(page, limit)} total={this.props.commendationData.total} />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6} lg={6} xs={24} sm={24}>
                        {this.props.advertisementData && this.props.advertisementData.images &&
                            <div className='banner-image'>
                                <ImagePresignedUrl src={this.props.advertisementData.images[0].url} />
                            </div>
                        }
                        <ServiceNavLink {...this.props} />
                    </Col>
                </Row>
                <AddSlide
                    visible={this.state.isAddSlideOpen}
                    onCancel={this.addSlideToggle}
                />
                <EditSlide
                    visible={this.state.isEditSlideOpen}
                    selectedRow={this.state.selectedRow}
                    onCancel={this.editSlideToggle}
                />
            </Layout>
        )
    }
}

function mapStateToProps(state) {
    return {
        commendationSuccess: state.client.commendations.commendationSuccess,
        addCommendationSuccess: state.client.commendations.addCommendationSuccess,
        updateCommendationSuccess: state.client.commendations.updateCommendationSuccess,
        commendationData: state.client.commendations.commendationData,
        commendationLoading: state.client.commendations.commendationLoading,
        deleteCommendationSuccess: state.client.commendations.deleteCommendationSuccess,
        advertisementData: state.client.advertisements.advertisementData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onSubmitCommendation: (data) => dispatch(submitCommendation(data)),
        onLoadCommendation: (data) => dispatch(loadCommendation(data)),
        onDeleteCommendation: (id) => dispatch(deleteCommendation(id)),
    }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Commendation)
)